<template>
    <div class="economy-learning-claims">
        <div class="placeholder">
            <div class="placeholder__heading">
                <d-tooltip placement="left" identifier="oekonomi.vaerdikaede" />
                Værdikæde
            </div>
            <div class="placeholder padding">
                <div class="lines" v-if="!loading">
                    <div class="line bold">
                        <div class="name">Pipeline</div>
                        <div class="revenue">Potentiel omsætning</div>
                        <div class="coverage">Potentielt DB</div>
                    </div>
                    <div class="line">
                        <div class="name">
                            {{ figures.offer.count }}
                            tilbud, der afventer afgørelse
                        </div>
                        <div class="revenue">
                            {{ figures.offer.expected_revenue | currency }}
                        </div>
                        <div class="coverage">
                            {{ figures.offer.expected_coverage | currency }}
                        </div>
                    </div>
                    <div class="line">
                        <div class="name">
                            {{ figures.open.count }}
                            opgaver, der ikke er påbegyndt
                        </div>
                        <div class="revenue">
                            {{ figures.open.expected_revenue | currency }}
                        </div>
                        <div class="coverage">
                            {{ figures.open.expected_coverage | currency }}
                        </div>
                    </div>
                    <div class="line">
                        <div class="name">
                            {{ figures.ongoing.count }}
                            igangværende opgaver, der arbejdes på
                        </div>
                        <div class="revenue">
                            {{ figures.ongoing.expected_revenue | currency }}
                        </div>
                        <div class="coverage">
                            {{ figures.ongoing.expected_coverage | currency }}
                        </div>
                    </div>
                    <div class="line">
                        <div class="name">
                            {{ figures.unbilled.count }}
                            afsluttede opgaver, der ikke er fakturerede
                        </div>
                        <div class="revenue">
                            {{ figures.unbilled.expected_revenue | currency }}
                        </div>
                        <div class="coverage">
                            {{ figures.unbilled.expected_coverage | currency }}
                        </div>
                    </div>
                    <div class="line">
                        <div class="name">
                            {{ figures.unpaid_invoices.count }}
                            fakturaer, der endnu ikke er betalt
                        </div>
                        <div class="revenue">
                            {{ figures.unpaid_invoices.expected_revenue | currency }}
                        </div>
                        <div class="coverage">
                            {{ figures.unpaid_invoices.expected_coverage | currency }}
                        </div>
                    </div>
                    <div class="line">
                        <div class="name">
                            {{ figures.overdue_invoices.count }}
                            fakturaer med overskredet betaling
                        </div>
                        <div class="revenue">
                            {{ figures.overdue_invoices.expected_revenue | currency }}
                        </div>
                        <div class="coverage">
                            {{ figures.overdue_invoices.expected_coverage | currency }}
                        </div>
                    </div>
                    <div class="line bold">
                        <div class="name">Total</div>
                        <div class="revenue">{{ revenueTotal | currency }}</div>
                        <div class="coverage">{{ coverageTotal | currency }}</div>
                    </div>
                </div>

                <box-loading height="350" v-else />

            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    .lines {

        .line {

            &.bold {
                font-weight: bold;
            }

            .name {
                flex: 0 0 50% !important;
            }

            .revenue {
                flex: 0 0 25%;
                text-align: right !important;
            }

            .coverage {
                flex: 0 0 25%;
                text-align: right !important;
            }
        }
    }

</style>

<script>
import * as calculationService from '@/services/calculationService'

export default {
    data () {
        return {
            loading: true,
            showChildren: true,
            figures: null
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            let params = {}
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            calculationService.valueChain(params, (response) => {
                this.figures = response.data
                if (this.$auth.user().name.includes('Demo')) {
                    this.figures.unbilled.count = 2
                    this.figures.unbilled.revenue = 80577
                    this.figures.unbilled.coverage = 35454
                    this.figures.unpaid_invoices.count = 8
                    this.figures.unpaid_invoices.revenue = 322311
                    this.figures.unpaid_invoices.coverage = 141816
                }
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        total () {
            let revenue = this.figures.expected_revenue + this.figures.revenue_in_pipeline
            let costs = this.figures.expected_costs
            return revenue - costs
        },
        globalParams () {
            // let startDate = this.$store.getters.getStartDate
            // let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return department
        },
        revenueTotal () {
            if (this.figures) {
                let total = this.figures.offer.expected_revenue +
                this.figures.open.expected_revenue +
                this.figures.ongoing.expected_revenue +
                this.figures.unbilled.expected_revenue +
                this.figures.unpaid_invoices.expected_revenue +
                this.figures.overdue_invoices.expected_revenue
                return total
            }
        },
        coverageTotal () {
            if (this.figures) {
                let total = this.figures.offer.expected_coverage +
                this.figures.open.expected_coverage +
                this.figures.ongoing.expected_coverage +
                this.figures.unbilled.expected_coverage +
                this.figures.unpaid_invoices.expected_coverage +
                this.figures.overdue_invoices.expected_coverage
                return total
            }
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// revenueAndCosts.vue?3ba7ebf8